import { makeStyle, makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    iconColor: {
        color: "#2962ff"
    }
}));